import { IUnrackItem } from "@store/unallocatedMiners/actionTypes";
import { Buffer } from "buffer";

const UNNALOCATED_KEY = `unnalocated`;

const storage = sessionStorage;

export const saveUnnalocatedPos = (unracks: IUnrackItem[]) => {
  const ids = new Set(unracks.map((p) => p.id));
  const string = [...ids].join();
  const endcoded = Buffer.from(string, "utf-8").toString("base64");
  storage.setItem(`${UNNALOCATED_KEY}`, endcoded);
  return unracks;
};

export const clearUnnalocatedPos = () => storage.removeItem(UNNALOCATED_KEY);

export const getSavedUnnalocatedPos = () => {
  const base64 = storage.getItem(`${UNNALOCATED_KEY}`);
  if (!base64) return;
  return Buffer.from(base64, "base64").toString().split(",");
};

export const checkingUnnalocatedPos = (unracks?: IUnrackItem[]) => {
  if (!unracks || !unracks.length) {
    clearUnnalocatedPos();
    return [];
  }
  const savedPositions = getSavedUnnalocatedPos();
  if (!savedPositions) return unracks;

  let filtered = [...unracks];
  const currentPositions: IUnrackItem[] = [];

  savedPositions?.forEach((sp) => {
    const index = filtered.findIndex((item) => item.id === +sp);
    if (index === -1) return;
    currentPositions.push(filtered[index]);
    filtered = [...filtered.slice(0, index), ...filtered.slice(index + 1)];
  });

  // возвращаем все что мы запушили в верном порядке + то, что осталось в настройках
  // это на случай если добавлены новыйе настройки, а порядок не сохранен
  return [...currentPositions, ...filtered];
};
